import { InputSize } from './Input.types';
import { FieldSize } from '../Field';
import { IconSize, TypoVariant } from '@/components';

export const CLEAR_BUTTON_ICON_SIZES = {
  [InputSize.S]: IconSize.M,
  [InputSize.M]: IconSize.M,
  [InputSize.L]: IconSize.L,
  [InputSize.XL]: IconSize.L,
};

export const INNER_TEXT_VARIANT_BY_SIZE = {
  [InputSize.S]: TypoVariant.BodyMRegular,
  [InputSize.M]: TypoVariant.BodyMRegular,
  [InputSize.L]: TypoVariant.BodyLRegular,
  [InputSize.XL]: TypoVariant.BodyXLRegular,
};

export const LABEL_SIZE = {
  [InputSize.S]: FieldSize.S,
  [InputSize.M]: FieldSize.M,
  [InputSize.L]: FieldSize.L,
  [InputSize.XL]: FieldSize.XL,
};
